import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISetKeyEventsDuration } from "../../@types/redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { IEventsData, ISetActiveEventCardData } from "../../../src/@types/api";
import { AnyARecord } from "dns";

interface IInitialState {
  activeDuration: string;
  activeIndex: number;
  activeEventCardData: IEventsData;
  timeLineEventData: [];
  activeYear: string;
}

interface AcyiveYear {
  activeYear: string | "";
}

const initialActiveEventCardData = {
  event_front_page_image: "",
  event_range: "",
  highlight: {
    highlight_image: "",
    highlight_text: "",
    highlight_title: "",
  },
  intro_image: "",
  long_title: "",
  main_text: "",
  year_title: "",
};

const initialState: IInitialState = {
  activeDuration: "1973-1982",
  activeIndex: 0,
  activeEventCardData: {
    ...initialActiveEventCardData,
  },
  timeLineEventData: [],
  activeYear: "",
};

const keyEventsSlice = createSlice({
  name: "keyEvents",
  initialState,
  reducers: {
    setEventDuration: (state, action: PayloadAction<ISetKeyEventsDuration>) => {
      state.activeDuration = action.payload.duration;
      state.activeIndex = action.payload.activeIndex;
    },
    setActiveEventCardData: (
      state,
      action: PayloadAction<ISetActiveEventCardData>
    ) => {
      state.activeEventCardData = {
        ...state.activeEventCardData,
        ...action.payload.eventData,
      };
    },
    setActiveYear: (state, action: PayloadAction<AcyiveYear>) => {
      state.activeYear = action.payload.activeYear;
    },
    seteventCardData: (state, action) => {
      const eventsData = action.payload.eventCardData;
      const  modifiedEventsData: any = [];
      const start = +state.activeDuration.split("-")[0];
      const end = +state.activeDuration.split("-")[1];
      for (let i = start; i <= end; i++) {
        modifiedEventsData.push({
          year_title: i.toString(),
          year_events: [],
        });
      }

      eventsData.forEach((elem: any, index: number) => {
        modifiedEventsData.forEach((el: any) => {
          if (elem.year_title === el.year_title) {
            el.year_events.push(elem);
          }
        });
      });
      state.timeLineEventData =  modifiedEventsData;
    },
  },
});

const keyEventsActions = keyEventsSlice.actions;

const persistConfig = {
  key: "uxpin-root-state",
  storage,
};

const keyEventsReducer = persistReducer(persistConfig, keyEventsSlice.reducer);

export { keyEventsActions, keyEventsReducer };
